import {Button} from '@tinct/web-components';
import {useStaticAssetsUrl} from '@tinct/core-utils';

type LandingPageErrorStateProps = {
  onRetry?: () => void;
  onContactSupport?: () => void;
  isRetrying?: boolean;
  errorCode?: string | null;
};

export const LandingPageErrorState = ({
  onRetry,
  onContactSupport,
  isRetrying,
  errorCode,
}: LandingPageErrorStateProps) => {
  const isCreditError = errorCode === 'not_enough_credits';
  const assetsUrl = useStaticAssetsUrl();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-8 text-center bg-muted">
      <img
        src={`${assetsUrl}/error-analyze.png`}
        alt=""
        className="h-[120px] w-auto pointer-events-none"
      />
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-semibold tracking-tight text-foreground">
          Unable to generate this variant
        </h2>
        <p className="max-w-md text-sm text-muted-foreground">
          {isCreditError
            ? 'You don\'t have enough credits to generate this variant. Upgrade your plan or retry once you have more credits.'
            : 'We couldn\'t generate a personalized version of your landing page for this company. This may be due to insufficient company data or incompatible page content.'}
        </p>
      </div>
      <div className="flex items-center gap-3">
        <Button onClick={onRetry} disabled={isRetrying}>
          {isRetrying ? 'Retrying...' : 'Retry'}
        </Button>
        <Button variant="outline" onClick={onContactSupport ?? (() => window.open('mailto:support@tinct.ai'))}>
          Contact support
        </Button>
      </div>
    </div>
  );
};
